import { Tag } from "@sprout/tag";
import type { ProfileData } from "@/queries/use_profile.ts";

type Props = {
  data: ProfileData;
};

const SkillsBody = ({ data }: Props) => (
  <div className="flex flex-wrap gap-2">
    {data.skills.map((skill) => (
      <Tag key={skill} label={skill} size="md" truncate={false} maxWidth="max-w-full" />
    ))}
  </div>
);

export default SkillsBody;
